module.exports = __webpack_public_path__ + "img/logo1.1ed235d5.png";